import React from 'react';

import styles from './index.module.scss';

type CheckboxProps = {
  isChecked: boolean;
};

const Checkbox = ({ isChecked }: CheckboxProps) => {
  return (
    <div
      className={
        isChecked
          ? styles['checkboxContainer-checked']
          : styles['checkboxContainer-unchecked']
      }
    >
      {isChecked ? <div className={styles.checkmark} /> : null}
    </div>
  );
};

export default Checkbox;
